var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_11810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7783 12.2393H51.6792C52.948 12.2393 53.9765 13.2669 53.9765 14.5412V18.8691C53.9765 20.8569 52.3611 22.4683 50.3774 22.4683H46.7783",
    stroke: "#FFBA01",
    strokeWidth: 3.68579,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2017 19.6748H31.7612V36.0413H38.2017V19.6748Z",
    fill: "#FFBA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6685 12.2393H18.7676C17.4988 12.2393 16.4702 13.2669 16.4702 14.5412V18.8691C16.4702 20.8569 18.0857 22.4683 20.0694 22.4683H23.6685",
    stroke: "#FFBA01",
    strokeWidth: 3.68579,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9813 30.6623C27.5179 30.6623 21.4941 24.6386 21.4941 17.1752V5.80957H48.4685V17.1752C48.4685 24.6386 42.4447 30.6623 34.9813 30.6623Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7252 4H22.2385C21.1004 4 20.1777 4.92263 20.1777 6.06075C20.1777 7.19888 21.1004 8.12151 22.2385 8.12151H47.7252C48.8633 8.12151 49.7859 7.19888 49.7859 6.06075C49.7859 4.92263 48.8633 4 47.7252 4Z",
    fill: "#FFBA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2324 34.9512H28.7303C27.8933 34.9512 27.2148 35.6296 27.2148 36.4666V38.9993H28.7303H41.2324H42.7478V36.4666C42.7478 35.6296 42.0693 34.9512 41.2324 34.9512Z",
    fill: "#FFE500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17.3525H8.60128",
    stroke: "#FFE600",
    strokeWidth: 3.05525,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3179 17.3525H63.7166",
    stroke: "#FFE600",
    strokeWidth: 3.05525,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48145 4.91992L10.076 8.27995",
    stroke: "#FFE600",
    strokeWidth: 3.05525,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8364 4.91992L62.2419 8.27995",
    stroke: "#FFE600",
    strokeWidth: 3.05525,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48145 29.7871L10.076 26.4271",
    stroke: "#FFE600",
    strokeWidth: 3.05525,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8364 29.7871L62.2419 26.4271",
    stroke: "#FFE600",
    strokeWidth: 3.05525,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2227,
    y: 39.0459,
    width: 33.6077,
    height: 27.9543,
    rx: 4.07366,
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5439,
    y: 59.8711,
    width: 40.9649,
    height: 7.12891,
    rx: 3.56445,
    fill: "#1899D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_11810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.817871 0.338867)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophy);
export default __webpack_public_path__ + "static/media/icon-trophy.6a54eeaa70e234991aa9c83dbcae89e2.svg";
export { ForwardRef as ReactComponent };